import {Directive, DirectiveBinding} from 'vue';
import {useUserStore} from '@/store/modules/user';

/**
 * 操作权限处理
 */
export const hasPermi: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const { permissions } = useUserStore();
    // 「其他角色」按钮权限校验
    const { value } = binding;
    if (value && value instanceof Array && value.length > 0) {
      const hasPermission = permissions.some((permi: string) => {
        return permi === '*:*:*' || value.includes(permi);
      });
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el);
        return false;
      }
    } else {
      throw new Error("check perms! Like v-has-permi=\"['system:user:add','system:user:edit']\"");
    }
  }
};
// export const hasPermi: Directive = {
//   mounted(el: HTMLElement, binding: DirectiveBinding) {
//     const { permissions } = useUserStore();
//     // 「其他角色」按钮权限校验
//     const { value } = binding;
//     if (value && Array.isArray(value) && value.length > 0) {
//       const hasPermission = permissions.some((permi) => {
//         // 确保 permi 是字符串类型
//         if (typeof permi === 'string') {
//           return permi === '*:*:*' || value.includes(permi);
//         }
//         return false;
//       });
//       if (!hasPermission) {
//         el.parentNode?.removeChild(el);
//       }
//     } else {
//       console.warn("check perms! Like v-has-permi=\"['system:user:add','system:user:edit']\"");
//     }
//   }
// };

/**
 * 角色权限处理
 */
export const hasRoles: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const { value } = binding;
    const { roles } = useUserStore();
    if (value && value instanceof Array && value.length > 0) {
      const hasRole = roles.some((role: string) => {
        return role === 'superadmin' || role === 'admin' || value.includes(role);
      });
      if (!hasRole) {
        el.parentNode && el.parentNode.removeChild(el);
        return false;
      }
    } else {
      throw new Error("check roles! Like v-has-roles=\"['admin','test']\"");
    }
  }
};

// 定义超级角色列表
// const SUPER_ROLES = ['superadmin', 'admin'];
// export const hasRoles: Directive = {
//   mounted(el: HTMLElement, binding: DirectiveBinding) {
//     const { value } = binding;
//     const { roles } = useUserStore();
//     if (value && Array.isArray(value) && value.length > 0) {
//       const hasRole = roles.some((role) => {
//         // 确保 role 是字符串类型
//         if (typeof role === 'string') {
//           return SUPER_ROLES.includes(role) || value.includes(role);
//         }
//         return false;
//       });
//       if (!hasRole) {
//         el.parentNode?.removeChild(el);
//       }
//     } else {
//       console.warn("check roles! Like v-has-roles=\"['admin','test']\"");
//     }
//   }
// };
